export const formatNumber = (n) => {
  if (n == null || n === "") return "—";
  const num = Number(n);
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1000) return (num / 1000).toFixed(1) + "K";
  return num.toLocaleString();
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const daysAgo = (iso) => {
  if (!iso) return null;
  try {
    return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  } catch { return null; }
};

export const scoreColor = (score) => {
  if (score >= 71) return "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/30";
  if (score >= 31) return "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/30";
  return "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/30";
};

export const ratingColor = (r) => {
  if (r == null) return "text-muted-foreground";
  if (r < 3.0) return "text-red-600 dark:text-red-400";
  if (r < 3.5) return "text-amber-600 dark:text-amber-400";
  if (r < 4.0) return "text-yellow-600 dark:text-yellow-400";
  return "text-emerald-600 dark:text-emerald-400";
};
